import React from 'react';

function Terms() {
  return (
    <div className="p-10 max-w-3xl mx-auto">
      <h1 className="text-3xl font-bold mb-4">Terms & Conditions</h1>
      <p>
        These are dummy terms and conditions for Learn&Grow. By using this platform, 
        you agree to follow all guidelines and policies. 
        We reserve the right to modify these terms at any time.
      </p>
    </div>
  );
}

export default Terms;
